// ABOUTME: Records the region a visitor picks from the footer switcher.
// ABOUTME: Loads independently of the gate — the switcher outlives it, and is the way back.

import { recordChoice } from './region-persistence.js';
import { storage } from './region-storage.js';

/*
 * Lifted out of region-banner.js when the banner was retired. It was never banner
 * behaviour: the switcher renders whenever `store_region` is set, including after
 * the gate has been answered and on stores where the gate is switched off, and it
 * is the only way a visitor can change their mind once a choice is on record.
 *
 * Deleting the banner without moving this would have left the switcher navigating
 * but not recording, so every region change would be forgotten and the gate would
 * ask again on arrival — with nothing failing to say so.
 */

// The footer switcher is rendered by a separate section and may not exist on
// every template — querySelectorAll returns nothing in that case, so the loop
// below is its own guard. Navigation is left alone; only the choice is recorded.
document.querySelectorAll('.region-switcher__link').forEach((el) => {
  el.addEventListener('click', () => recordChoice(storage, el.dataset.region));
});
